import PipettingItemTipPosition from './PipettingItemTipPosition';
import PipettingItemSpeed from './PipettingItemSpeed';
import PipettingItemRetractSpeed from './PipettingItemRetractSpeed';
import PipettingItemEnableMixingSwitch from './PipettingItemEnableMixing';
import PipettingItemMixingSpeed from './PipettingItemMixingSpeed';
import PipettingItemMixingDetailGroup from './PipettingItemMixingDetailGroup';
import PipettingItemPrecisionDispense from './PipettingItemPrecisionDispense';
import PipettingItemTipTouchOff from './PipettingItemTipTouchOff';
import PipettingItemCopyPipettingValueButton from './PipettingItemCopyPipettingValueButton';
import PipettingItemReuseTip from './PipettingItemReuseTip';

const PipettingProfileItems = () => {};

PipettingProfileItems.TipPosition = PipettingItemTipPosition;
PipettingProfileItems.Speed = PipettingItemSpeed;
PipettingProfileItems.RetractSpeed = PipettingItemRetractSpeed;
PipettingProfileItems.EnableMixing = PipettingItemEnableMixingSwitch;
PipettingProfileItems.MixingSpeed = PipettingItemMixingSpeed;
PipettingProfileItems.MixingDetailGroup = PipettingItemMixingDetailGroup;
PipettingProfileItems.PrecisionDispense = PipettingItemPrecisionDispense;
PipettingProfileItems.TipTouchOff = PipettingItemTipTouchOff;
PipettingProfileItems.CopyPipettingValueButton = PipettingItemCopyPipettingValueButton;
PipettingProfileItems.ReuseTips = PipettingItemReuseTip;

export default PipettingProfileItems;
